import {
  type ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideCoreAuth } from '@core/auth/provide-core-auth';
import { RU } from '@core/config/primeng-ru.translation';
import { appConfigProviders } from '@core/config/provide-app-config';
import { GlobalErrorHandler } from '@core/error-handling/global-error-handler';
import { provideCoreHttp } from '@core/http/provide-core-http';
import { auraCustomPreset } from '@shared/themes/aura-custom-theme';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    // Config must load before HTTP/auth initializers (AuthService → CsrfTokenService / ApiHttpClient → APP_CONFIG).
    ...appConfigProviders,
    provideCoreHttp(),
    ...provideCoreAuth(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: auraCustomPreset,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng, components, utilities',
          },
          ripple: true,
        },
      },
      translation: RU,
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
